import { DisplaySize } from "@lhd/constants";
import { Pagination, PaginationProps } from "antd";
import { memo } from "react";
import { Styles } from "./styled";
const DEFAULT_PAGE_SIZE_OPTIONs = [10, 20, 30, 50];
export interface IProps extends PaginationProps {
  justify?: "end" | "center" | "start";
  showPageChanger?: boolean;
  displaySize: DisplaySize;
}
const PaginationCustom = memo(function PaginationCustom({
  justify,
  showPageChanger = true,
  displaySize = "small",
  ...restProps
}: IProps) {
  const showSizeChanger = restProps.showSizeChanger ?? true;
  return (
    <Styles
      justify={justify}
      showPageChanger={showPageChanger}
      displaySize={displaySize}
      $isDefaultValue={restProps.pageSize === 50}
    >
      {showSizeChanger && <b>表示:</b>}
      <Pagination
        {...restProps}
        size={"default"}
        onChange={(page: number, pageSize: number) => {
          restProps.onChange && restProps.onChange(page, pageSize);
        }}
        showSizeChanger={showSizeChanger}
        locale={{
          items_per_page: "",
          ...restProps.locale,
        }}
        pageSizeOptions={restProps.pageSizeOptions || DEFAULT_PAGE_SIZE_OPTIONs}
      />
    </Styles>
  );
});

export default PaginationCustom;
